import React from 'react';
import {
  useParams,
} from 'react-router-dom';
import NewsletterForm from '../components/newsletter-form';
import Layout from '../components/layout';
import LinkButton from '../components/link-button';
import PageHeader from '../components/page-header';
import './page.css';

const NewsletterPage = () => {
  const { id } = useParams();

  return (
    <Layout>
      <div className="page">
        <PageHeader
          title={`${id ? 'Modifier' : 'Créer'} une newsletter`}
        />

        <div className="page_actions">
          <LinkButton
            className="page_action-button"
            icon="arrow_back"
            label="Retour"
            to="/newsletters"
            theme="danger"
          />
        </div>

        <NewsletterForm id={parseInt(id, 10)} />
      </div>
    </Layout>
  );
};

export default NewsletterPage;
